import {Home} from '@/layout'

export default {
    path: '/backstage',
    component: Home,
    meta: {
        roles: ['dev'],
        childrenRoles: false
    },
    children: [
        {
            path: '',
            component: () => import('@/page/backstage'),
            children: [
                {
                    path: '',
                    meta: {
                        title: '品牌管理'
                    },
                    component: () => import('@/page/backstage/organization')
                },
                {
                    path: 'banner',
                    meta: {
                        title: 'Banner管理'
                    },
                    component: () => import('@/page/backstage/banner')
                },
                {
                    path: 'question',
                    meta: {
                        title: '考试题库'
                    },
                    component: () => import('@/page/backstage/question')
                },
                {
                    path: 'exam',
                    meta: {
                        title: '等级考试'
                    },
                    component: () => import('@/page/backstage/exam')
                },
                {
                    path: 'activity',
                    meta: {
                        title: '社区活动'
                    },
                    component: () => import('@/page/backstage/activity')
                },
            ]
        }
    ]
}
